import { filterBy } from "@progress/kendo-data-query";
import { Button } from "@progress/kendo-react-buttons";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import {
  FormCheckbox,
  FormInput,
  FormDatePicker,
  FormMultiSelect,
} from "commons/forms/form";
import { required } from "commons/forms/validators";
import React, { useState } from "react";

export default function BannerItem(props) {
  const { bin, path, save, remove, categories } = props;
  const [categoriesList, setCategoriesList] = useState(categories);

  const clickHRefValidator = (e) => required(e, "Référence");
  const dateDebutValidator = (e) => required(e, "Date début");
  const dateLimiteValidator = (e) => required(e, "Date de fin");

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span
        onClick={() => remove(path)}
        style={{ fontSize: "20px", alignSelf: "end", marginRight: "10px" }}
        className="k-icon k-font-icon k-i-close"
      />

      <Form
        initialValues={{
          clickHref: "https://tanguay.ca",
          dateLimite: new Date(new Date().setHours(0, 0, 0, 0)),
          dateDebut: new Date(new Date().setHours(0, 0, 0, 0)),
          path: path,
          priority: 99,
          bin: bin,
          created_at: new Date(),
        }}
        onSubmit={save}
        render={(formRenderProps) => (
          <FormElement>
            <fieldset className={"k-form-fieldset"}>
              <div className="row">
                <div className="col-md-6">
                  <img
                    style={{
                      height: "23rem",
                      margin: "auto",
                      display: "block",
                    }}
                    alt={path.split(".")[0]}
                    src={"data:image/png;base64," + bin}
                  />
                </div>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-12">
                      <Field
                        id={"clickHref"}
                        name={"clickHref"}
                        label={"Référence click"}
                        component={FormInput}
                        wrapperStyle={{
                          marginRight: "18px",
                        }}
                        validator={clickHRefValidator}
                      />
                      <Field
                        type={"number"}
                        id={"priority"}
                        name={"priority"}
                        label={"Priorité"}
                        component={FormInput}
                        wrapperStyle={{
                          marginRight: "18px",
                        }}
                      />
                      <Field
                        id={"categories"}
                        name={"categories"}
                        label={"Catégories"}
                        component={FormMultiSelect}
                        optional={false}
                        data={categoriesList}
                        filterable={true}
                        onFilterChange={(e) => {
                          setCategoriesList(
                            filterBy(categories.slice(), e.filter)
                          );
                        }}
                        wrapperStyle={{
                          marginRight: "18px",
                        }}
                      />
                      <Field
                        id={"dateDebut "}
                        name={"dateDebut"}
                        label={"Date début"}
                        component={FormDatePicker}
                        validator={dateDebutValidator}
                        wrapperStyle={{
                          minWidth: "10rem",
                          width: "12%",
                          marginRight: "15px",
                        }}
                      />
                      <Field
                        id={"dateLimite"}
                        name={"dateLimite"}
                        label={"Date limite"}
                        component={FormDatePicker}
                        validator={dateLimiteValidator}
                        wrapperStyle={{
                          minWidth: "10rem",
                          width: "12%",
                          marginRight: "15px",
                        }}
                      />
                      <Field
                        id={"all"}
                        name={"all"}
                        label={"Afficher dans toutes les catégories"}
                        component={FormCheckbox}
                      />
                      <div className="k-form-buttons">
                        <Button
                          style={{ backgroundColor: "#538199" }}
                          type={"submit"}
                        >
                          Enregistrer
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </FormElement>
        )}
      />

      <div
        style={{
          height: "1px",
          backgroundColor: "lightgray",
          margin: "25px 0 5px 0",
        }}
      ></div>
    </div>
  );
}
